import { Component, Input, inject } from '@angular/core';
import { CaptureValidationService } from '../../../core/services/capture-validation.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-verification-validation',
    templateUrl: './verification-validation.component.html',
    styleUrls: ['./verification-validation.component.scss'],
    imports: [NgClass]
})
export class VerificationValidationComponent {
  private captureValidationService = inject(CaptureValidationService);

  @Input() key: string;

  get hasError(): boolean {
    return !!this.captureValidationService.getError(this.key);
  }

  get errorMessage(): string {
    return this.captureValidationService.getError(this.key);
  }
}
